$(function(){
    
    //stream slider
    if ($(window).width() > 767) {
        let $streamSlider = new Swiper('.js-stream-slider', {
            slidesPerView: 3,
            spaceBetween: 30,
            loop: false,
            speed: 1000,
            pagination: {
                el: '.stream__slider-pagination',
                type: 'fraction'
            },
            breakpoints: {
                1024: {
                    slidesPerView: 1.9,
                },
            },
            navigation: {
                nextEl: ".stream__slider-arr._next",
                prevEl: ".stream__slider-arr._prev",
            },
        });
    }
    $('.js-stream-btn').on('click', function () {
        $(this).fadeOut()
        $('.js-stream-cards').addClass('_opened')
    })

    // nominations slider
    let $nominationsSlider = new Swiper('.js-nominations-slider', {
        slidesPerView: 4,
        spaceBetween: 15,
        loop: false,
        speed: 1000,
        breakpoints: {
            1279: {
                slidesPerView: 2,
                slidesPerColumn: 2,
            },
        },
        navigation: {
            nextEl: ".n-slider__arr._next",
            prevEl: ".n-slider__arr._prev",
        },
        
    });
    
})